// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".redCheckoutVue .redStepFinal_WrapperSticky_DESKTOP[data-v-415ce160]{position:sticky;top:88px}@media only screen and (min-width: 768px){.redCheckoutVue .redStepFinal_WrapperSticky_MOBILE[data-v-415ce160]{position:sticky;top:24px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
